<script setup lang="ts">
definePageMeta({
	name: 'error-page',
	title: `Error`,
});

const err = useError();

console.error(err.value);

// Determine error type and page metadata
const isNotFound = err.value?.statusCode === 404;

// Error messaging based on status code
const errorConfig = computed(() => {
	const statusCode = err.value?.statusCode || 500;

	if (statusCode === 404) {
		return {
			title: 'Page not found!',
			message: 'The page may have been moved, or the URL has expired and is no longer accessible.',
			buttonText: 'Return to Homepage',
		};
	}
	else if (statusCode >= 500) {
		return {
			title: 'Server Error!',
			message: 'Something went wrong on our end. Please try again later or contact support if the problem persists.',
			buttonText: 'Try Again',
		};
	}
	else {
		return {
			title: 'Something went wrong!',
			message: 'An unexpected error occurred. Please try again or contact support if the problem persists.',
			buttonText: 'Return to Homepage',
		};
	}
});

function handleError() {
	const statusCode = err.value?.statusCode || 500;

	// For server errors, try refreshing the page first
	if (statusCode >= 500) {
		window.location.reload();
	}
	else {
		clearError({ redirect: '/' });
	}
}
</script>

<template>
	<NuxtLayout name="default">
		<div class="container:md py:160">
			<div class="error-page">
				<div class="error-page__header">
					<HmLogo :to="{ name: 'index' }" />
					<div class="error-page__content">
						<h1 class="h2">
							{{ errorConfig.title }}
						</h1>
						<p>{{ errorConfig.message }}</p>
					</div>
					<div class="error-page__code" v-if="err?.statusCode">
						<span>Error code:</span>
						<span class="fw:500">{{ err.statusCode }}</span>
					</div>
				</div>
				<div class="error-page__body">
					<div class="error-page__message" v-if="err?.message && !isNotFound">
						<span>Error Message:</span>
						<p class="fw:500">
							{{ err.message }}
						</p>
					</div>
					<div class="error-page__404" v-else-if="isNotFound">
						<span>404</span>
						<span class="error-page__404-decoration"></span>
					</div>
				</div>
				<div class="error-page__footer">
					<HmButton
						:label="errorConfig.buttonText"
						variant="solid"
						is-wide
						@click="handleError"
					/>
					<HmButton
						label="Contact support"
						:to="useHelpPortalURL()"
						is-wide
					/>
				</div>
			</div>
		</div>
	</NuxtLayout>
</template>
